import { lumi } from '@/lib/lumi'
import type { NewsArticle } from '@/types/news'
import { useCallback, useEffect, useState } from 'react'

export function useNews(publishedOnly = false) {
  const [articles, setArticles] = useState<NewsArticle[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const refresh = useCallback(async () => {
    setLoading(true)
    setError('')
    try {
      const { list } = await lumi.entities.news.list({
        filter: publishedOnly ? { published: true } : {},
        sort: { createdAt: -1 },
        limit: 200,
      })
      setArticles((list as NewsArticle[]) || [])
    } catch (err) {
      console.error('Falha ao carregar notícias:', err)
      setArticles([])
      setError('Não foi possível carregar as notícias.')
    } finally {
      setLoading(false)
    }
  }, [publishedOnly])

  useEffect(() => {
    void refresh()
  }, [refresh])

  return { articles, loading, error, refresh }
}
